import jquery from 'jquery';
import moment from 'moment';

const registerGlobals = (globalObject) => {
  globalObject.jQuery = globalObject.$ = jquery;
  globalObject.moment = globalObject.Moment = moment;
};

try {
  registerGlobals(window);
} catch (err) {
  // when in worker, use self instead
  registerGlobals(self);
}

// iOS Safari suppresses click events on the first tap after a scroll gesture
// unless the document has at least one touchstart listener registered.
// This no-op passive listener disables that heuristic app-wide.
if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function() {}, { passive: true });
}
